import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { useEffect, useRef, useState } from "react";

import { Pencil } from "lucide-react";
import { PaginationControl } from "@/widgets/renderPagination";
import { useGetAdditionalOffers } from "@/hooks/useLocalStorage";
import { AlertDialog } from "@/widgets/AlertDailog";
import { AdditionalOfferForm, OfferForm } from "@/shared/partnerschema";
import AddAdditionalOffer from "./AddAdditionalOffer";
import RulesSetup from "./RulesSetup";
import RulesPopup from "./RulesPopup";
import { Button } from "../ui/button";

function AdditionalOffer() {
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize] = useState(10);

    const [openAddOffer, setOpenAddOffer] = useState(false);
    const [offerData, setOfferData] = useState<AdditionalOfferForm | null>(null);

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertDataObj, setAlertDataObj] = useState<{ message: string; status: boolean }>({
        message: "",
        status: false,
    });

    const [openRulesPopup, setOpenRulesPopup] = useState(false);
    const [openRulesSetUpPopup, setOpenRulesSetUpPopup] = useState(false);
    const [viewType, setViewType] = useState(false);
    const [selectedOfferData, setSelectedOfferData] = useState<OfferForm>({
        Id: 0,
        ExchangeOfferName: "",
        ExPartnerId: 0,
        OfferDetails: "",
        CreatedDate: "",
    });
    const didRedirectRef = useRef(false);

    // Wouter: read state pushed via window.history.pushState
    const partdata = (window.history.state as any)?.partnerData;
    const offerId: number = partdata?.Id ?? 0;
console.log("partdata", partdata)
    const { data: additionalOffers, isLoading } = useGetAdditionalOffers(offerId, pageIndex, pageSize);

    const handleEditOffer = (data: AdditionalOfferForm) => {
        setOfferData(data);
        setOpenAddOffer(true);
    };

    const handleCloseModal = () => {
        setOpenAddOffer(false);
        setOfferData(null);
    };

    const handleMutationResult = (success: boolean, message: string) => {
        setOpenAddOffer(false);
        setAlertDataObj({ status: success, message });
        setAlertOpen(true);
    };

    const items = additionalOffers?.data?.items ?? [];
    const totalCount = additionalOffers?.data?.total ?? 0;

    const handleSetupOffer = (data: any) => {
        console.log("data11", data)
        const payload = JSON.stringify({
            Id: data.Id,
            ExchangeOfferName: data.ExchangeOfferName,
            ExPartnerId: data?.ParrentId,
            OfferDetail: data.AdditionalOfferDetails,
            CreatedDate: data.CreatedDate,
            ModifiedDate: data.ModifiedDate,
            IsActive: true,
            ReferenceFormId: data.ReferenceFormId,
        });

        document.cookie = `defaultOffer_setup=${encodeURIComponent(payload)}; domain=.workfinity.com; path=/; max-age=300`;
        window.location.href = "https://form-ai-portal.workfinity.com/additionaldefaultOffers";
    };

    return (
        <div className="px-8 pt-4 pb-2 space-y-2">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h2 className="text-lg md:text-xl font-bold text-gray-900">
                        Manage {partdata?.OfferType ? "Individual" : "XChange"} Additional Offer
                    </h2>
                    <p className="text-gray-700 mt-1 text-sm md:text-base">
                        {partdata?.OfferType ? "Individual" : "XChange"} Partners Linked:{" "}
                        <span className="text-slate-900 font-medium">{partdata?.ExchangeOfferName}</span>
                    </p>
                </div>

                <div className="flex gap-2">
                    <button
                        className="flex items-center bg-[#1342CD] text-white px-4 py-2 rounded-sm hover:bg-[#0f35a8] transition-colors"
                        onClick={() => setOpenAddOffer(true)}
                    >
                        Add Additional Offer
                    </button>
                    <button
                        className="flex items-center bg-black px-6 text-white py-2 rounded-sm hover:bg-gray-800 transition-colors"
                        onClick={() => window.history.back()}
                    >
                        Back
                    </button>
                </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
                <div className="overflow-x-auto">
                    <Table>
                        <TableHeader>
                            <TableRow className="bg-gray-300">
                                <TableHead className="px-4 py-4">Id</TableHead>
                                <TableHead className="px-4 py-3">Offer Name</TableHead>
                                <TableHead className="px-4 py-3">Raw Rule</TableHead>
                                <TableHead className="px-4 py-3">
                                    Rule With Values
                                    <br />
                                    (Published to workflow)
                                </TableHead>
                                <TableHead className="px-4 py-3">Set Additional Offer</TableHead>
                                <TableHead className="px-4 py-3">View Additional Offer</TableHead>
                                <TableHead className="px-4 py-3">Last Modified</TableHead>
                                <TableHead className="px-4 py-3">Actions</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {items.length > 0 ? (
                                items.map((data) => (
                                    <TableRow key={data.Id} className="hover:bg-gray-50 transition-colors">
                                        <TableCell className="px-4 py-3 font-mono">{data.Id}</TableCell>

                                        <TableCell className="px-4 py-3 font-medium">
                                            {data.ExchangeOfferName}
                                        </TableCell>

                                        <TableCell className="px-4 py-3">
                                            <button
                                                onClick={() => {
                                                    setOpenRulesPopup(true);
                                                    setSelectedOfferData(data);
                                                }}
                                                className="p-2 cursor-pointer text-blue-700 transition-colors"
                                            >
                                                View
                                            </button>
                                        </TableCell>

                                        <TableCell className="px-4 py-3">
                                            <button
                                                onClick={() => {
                                                    setOpenRulesSetUpPopup(true);
                                                    setSelectedOfferData(data);
                                                    setViewType(true);
                                                }}
                                                className="p-2 cursor-pointer text-blue-700 transition-colors"
                                                title="Offers"
                                            >
                                                View
                                            </button>
                                        </TableCell>

                                        <TableCell className="px-4 py-3 max-w-xs truncate">
                                            <button
                                                onClick={() => handleSetupOffer(data)}
                                                className="p-2 cursor-pointer text-blue-700 transition-colors"
                                                title="Setup Default Offer"
                                            >
                                                Setup Offer
                                            </button>
                                        </TableCell>

                                        <TableCell className="px-4 py-3 max-w-xs truncate">
                                            <Button
                                                variant="link"
                                                className="max-w-xs truncate"
                                                disabled={!data?.ReferenceFormId}
                                                onClick={() => {
                                                    if (data?.ReferenceFormId) {
                                                        window.open(
                                                            `https://form-engine.workfinity.com/designer/${data.ReferenceFormId}`,
                                                            "_blank"
                                                        );
                                                    }
                                                }}
                                            >
                                                View Offer
                                            </Button>
                                        </TableCell>

                                        <TableCell className="px-4 py-3 whitespace-nowrap">
                                            {/* {formatDateTime(data.ModifiedDate ?? "")} */}
                                            <div className="flex flex-col">
                                                {data.ModifiedDate ? (
                                                    <>
                                                        <span>
                                                            {new Date(data.ModifiedDate).toLocaleDateString("en-IN", {
                                                                day: "2-digit", month: "short", year: "numeric",
                                                            })}
                                                        </span>
                                                        <span className="text-xs text-black">
                                                            {new Date(data.ModifiedDate).toLocaleTimeString("en-IN", {
                                                                hour: "2-digit", minute: "2-digit",
                                                            })}
                                                        </span>
                                                    </>
                                                ) : "-"}
                                            </div>
                                        </TableCell>

                                        <TableCell className="px-4 py-3">
                                            <button
                                                onClick={() => handleEditOffer(data)}
                                                className="p-2 cursor-pointer hover:bg-slate-200 rounded-md transition-colors"
                                                title="Edit Additional Offer"
                                            >
                                                <Pencil className="h-4 w-4" />
                                            </button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} className="text-center py-8 text-gray-500">
                                        No Additional Offers found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    {!isLoading && items.length > 0 && (
                        <div className="float-end mb-2 mr-4">
                            <PaginationControl
                                pageIndex={pageIndex}
                                pageSize={pageSize}
                                totalCount={totalCount}
                                onPageChange={setPageIndex}
                            />
                        </div>
                    )}
                </div>
            </div>

            <AddAdditionalOffer
                open={openAddOffer}
                onClose={handleCloseModal}
                data={offerData}
                offerId={offerId}
                onMutationResult={handleMutationResult}
            />

            {openRulesPopup && (
                <RulesPopup
                    open={openRulesPopup}
                    onClose={() => setOpenRulesPopup(false)}
                    offerData={partdata}
                />
            )}

            {openRulesSetUpPopup && (
                <RulesSetup
                    open={openRulesSetUpPopup}
                    onClose={() => setOpenRulesSetUpPopup(false)}
                    offerData={partdata}
                    viewType={viewType}
                />
            )}

            <AlertDialog
                open={alertOpen}
                onOpenChange={setAlertOpen}
                message={alertDataObj.message}
                status={alertDataObj.status}
            />
        </div>
    );
}

export default AdditionalOffer;